import { Card, type CardProps } from 'tamagui'

export default function CobuCard(props: CardProps) {
  return (
    <Card
      backgroundColor="$cardBackground"
      borderColor="$cardBorderColor"
      borderWidth={"$strokeHairline" as any}
      borderRadius={"$cardRadius" as any}
      {...props}
    />
  )
}
